<template>
  <div class="outside_wrap">
    <uni-popup ref="leadDrug" type="bottom" @change="changeVisible">
      <uni-card title="选择处方" :is-full="true" :note="true" :mask-click="false">
        <!-- <ms-tabs
          v-if="isOpenPop"
          v-model="activeIndex"
          class="sticky-box"
          :list="tabs"
          lineColor="#0089FF"
          itemColor="#0089FF"
        /> -->
        <div v-if="[1].includes(activeIndex) && !disconnectHis" class="channelClass">
          <uni-tag
            class="mr20"
            text="互联网医院"
            type="primary"
            size="small"
            :inverted="channel !== 1"
            @click="changeChannel(1)"
          />
          <uni-tag
            class="mr20"
            text="咨询"
            type="primary"
            size="small"
            :inverted="channel !== 2"
            @click="changeChannel(2)"
          />
        </div>
        <div class="gridClass">
          <div
            v-if="
              tabs[activeIndex].prescripChannel
                ? tabs[activeIndex].type[channel - 1].list[0]
                : tabs[activeIndex].list[0]
            "
            class="ofPatient"
          >
            <scroll-view
              :upper-threshold="-50"
              :scroll-top="0"
              :scroll-y="true"
              :scroll-anchoring="true"
              style="height: 18.346667rem"
              @scrolltolower="getMoreList"
            >
              <ms-lead-item
                :prescriptionList="
                  tabs[activeIndex].prescripChannel
                    ? tabs[activeIndex].type[channel - 1].list
                    : tabs[activeIndex].list
                "
                :activeIndex="activeIndex"
                @updateDrug="updateDrug"
              />
            </scroll-view>
            <!-- 到底提示 -->
            <div
              v-if="
                tabs[activeIndex].prescripChannel
                  ? tabs[activeIndex].type[channel - 1].list[0] &&
                    tabs[activeIndex].type[channel - 1].isDone
                  : tabs[activeIndex].list[0] && tabs[activeIndex].isDone
              "
              class="isBottom"
            >
              <span>已经到底啦～</span>
            </div>
          </div>
          <gl-no-content v-else :title="'暂无数据'" />
        </div>
        <template v-slot:footer>
          <div class="footer-box" @click="selectPrescrip">
            <span class="btn">选择该处方</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-lead-update
      ref="leadUpdate"
      v-model:visible="showLeadUpdate"
      :updateDrugData="updateDrugData"
      :channel="channel"
    />
  </div>
</template>
<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import { fSearchPrescription, fGetPrescripTemplate } from '@/views/funcPuzzle/utils/index.js'
import { disconnectHis } from '@/views/funcPuzzle/utils/business'
import { mapState } from 'vuex'
import GlNoContent from '@/views/funcPuzzle/home/components/gl-no-content'
// import MsTabs from '@/views/funcPuzzle/components/ms-tabs/ms-tabs.vue'
import MsLeadItem from '@/views/funcPuzzle/components/ms-lead-item/ms-lead-item.vue'
import MsLeadUpdate from '@/views/funcPuzzle/components/ms-lead-update/ms-lead-update.vue'

export default {
  components: {
    GlNoContent,
    // MsTabs,
    MsLeadItem,
    MsLeadUpdate
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    prescripList: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    prescripType: {
      type: [Object, String],
      default: ''
    },
    diagnosis: {
      type: [Object, String],
      default: ''
    },
    patientID: {
      type: [Object, String],
      default: ''
    },
    patientName: {
      type: [Object, String],
      default: ''
    },
    warehouseID: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      activeIndex: 0,
      disconnectHis: disconnectHis(),
      showAddDrug: false,
      showPrescription: false,
      prescripItem: '',
      seletedIndex: '',
      tabs: [
        {
          title: '相同诊断',
          isDone: false,
          query: {
            doctorID: '',
            doctorName: '',
            patientID: '',
            patientName: '',
            diagnosis: '',
            drugName: '',
            pageNum: 1,
            pageSize: 10
          },
          list: []
        },
        {
          title: '同一受者',
          prescripChannel: 1,
          type: [
            {
              isDone: false,
              query: {
                doctorID: '',
                doctorName: '',
                patientID: '',
                patientName: '',
                diagnosis: '',
                drugName: '',
                prescripChannel: 1,
                pageNum: 1,
                pageSize: 10
              },
              list: []
            },
            {
              isDone: false,
              query: {
                doctorID: '',
                doctorName: '',
                patientID: '',
                patientName: '',
                diagnosis: '',
                drugName: '',
                prescripChannel: 2,
                pageNum: 1,
                pageSize: 10
              },
              list: []
            }
          ]
        },
        {
          title: '我的处方',
          isDone: false,
          query: {
            pageNum: 1,
            pageSize: 10,
            doctorID: '',
            state: '1',
            templateType: '1',
            hospitalID: ''
          },
          list: []
        },
        {
          title: '公共处方',
          isDone: false,
          query: {
            pageNum: 1,
            pageSize: 10,
            doctorID: '',
            state: '1',
            templateType: '2',
            hospitalID: ''
          },
          list: []
        }
      ],
      showLeadUpdate: false,
      prescriptionList: [],
      timer: null,
      updateDrugData: '',
      isOpenPop: false,
      channel: 1
    }
  },
  computed: {
    ...mapState(['doctor']),
    tabList() {
      return this.tabs[this.activeIndex]
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.open()
        setTimeout(() => {
          this.isOpenPop = true
          if (
            this.tabList.prescripChannel
              ? !this.tabList.type[this.channel - 1].list[0]
              : !this.tabList.list[0]
          ) {
            this.getPreList()
          }
        }, 200)
      } else {
        this.isOpenPop = false
        this.close()
      }
    },
    modelValue(val) {
      this.$emit('update:modelValue', val)
    },
    doctor: {
      handler(val) {},
      immediate: true
    },
    activeIndex: {
      handler(val) {
        this.tabList.prescripChannel
          ? (this.tabList.type[this.channel - 1].query.pageNum = 1)
          : (this.tabList.query.pageNum = 1)
        this.getPreList()
      }
    }
  },
  methods: {
    getKeyValueText,
    async getPreList() {
      const { diagnosis, tabList } = this

      const params = tabList.prescripChannel ? tabList.type[this.channel - 1].query : tabList.query

      params.prescripType = this.prescripType
      // 服务端数据格式改变，可能为数组
      // 取第一个诊断值
      params.diagnosis =
        this.activeIndex === 0 && diagnosis && diagnosis[0] ? diagnosis[0].symptomName : ''
      params.patientID = this.activeIndex === 1 ? this.patientID : ''
      params.doctorID = [0, 1, 2].includes(this.activeIndex) ? this.doctor.doctorID : ''

      uni.showLoading({
        title: '加载中',
        mask: true
      })
      await this.searchPrescription()
    },
    getMoreList() {
      this.tabList.prescripChannel
        ? this.tabList.type[this.channel - 1].query.pageNum++
        : this.tabList.query.pageNum++
      if (
        this.tabList.prescripChannel
          ? !this.tabList.type[this.channel - 1].isDone
          : !this.tabList.isDone
      ) {
        this.searchPrescription()
      }
    },
    async searchPrescription() {
      let params = this.tabList.prescripChannel
        ? this.tabList.type[this.channel - 1].query
        : this.tabList.query

      if ([2, 3].includes(this.activeIndex)) {
        params = {
          ...params,
          hospitalID: this.doctor.hospitalID
        }
      }

      params = {
        ...params,
        warehouseID: this.warehouseID
      }

      const requestName = [0, 1].includes(this.activeIndex)
        ? 'fSearchPrescription'
        : 'fGetPrescripTemplate'

      await this.requestPromise(requestName, params)
    },
    async requestPromise(requestName, params) {
      if (requestName === 'fSearchPrescription') {
        await fSearchPrescription(params).then(rs => {
          const response =
            requestName === 'fSearchPrescription' ? rs.prescriptionList : rs.PrescripTemplateList
          // 同一受者 门诊特殊判断
          if (requestName === 'fSearchPrescription' && response && response.length > 0) {
            for (let i = 0; i < response.length; i++) {
              const item = response[i]
              const { hisPrescripNum } = item
              if (hisPrescripNum) {
                response[i].prescripNum = hisPrescripNum
              }
            }
          }
          // 同一受者 门诊特殊判断 end
          if (response.length === 0) {
            this.tabList.prescripChannel
              ? (this.tabList.type[this.channel - 1].isDone = true)
              : (this.tabList.isDone = true)
          }

          const pageNum = this.tabList.prescripChannel
            ? this.tabList.type[this.channel - 1].query.pageNum
            : this.tabList.query.pageNum

          if (pageNum === 1) {
            this.tabList.prescripChannel
              ? (this.tabList.type[this.channel - 1].list = response)
              : (this.tabList.list = response)
          } else {
            this.tabList.prescripChannel
              ? (this.tabList.type[this.channel - 1].list = [
                  ...this.tabList.type[this.channel - 1].list,
                  ...response
                ])
              : (this.tabList.list = [...this.tabList.list, ...response])
          }
          uni.hideLoading()
        })
      }
      if (requestName === 'fGetPrescripTemplate') {
        await fGetPrescripTemplate(params).then(rs => {
          const response =
            requestName === 'fSearchPrescription' ? rs.prescriptionList : rs.PrescripTemplateList
          // 同一受者 门诊特殊判断
          if (requestName === 'fSearchPrescription' && response && response.length > 0) {
            for (let i = 0; i < response.length; i++) {
              const item = response[i]
              const { hisPrescripNum } = item
              if (hisPrescripNum) {
                response[i].prescripNum = hisPrescripNum
              }
            }
          }
          // 同一受者 门诊特殊判断 end
          if (response.length === 0) {
            this.tabList.prescripChannel
              ? (this.tabList.type[this.channel - 1].isDone = true)
              : (this.tabList.isDone = true)
          }

          const pageNum = this.tabList.prescripChannel
            ? this.tabList.type[this.channel - 1].query.pageNum
            : this.tabList.query.pageNum

          if (pageNum === 1) {
            this.tabList.prescripChannel
              ? (this.tabList.type[this.channel - 1].list = response)
              : (this.tabList.list = response)
          } else {
            this.tabList.prescripChannel
              ? (this.tabList.type[this.channel - 1].list = [
                  ...this.tabList.type[this.channel - 1].list,
                  ...response
                ])
              : (this.tabList.list = [...this.tabList.list, ...response])
          }
          uni.hideLoading()
        })
      }
    },
    updateDrug(item) {
      this.updateDrugData = item
    },
    selectPrescrip() {
      if (
        this.tabList.prescripChannel
          ? this.tabList.type[this.channel - 1].list[0]
          : this.tabList.list[0]
      ) {
        this.showLeadUpdate = true
        // this.$refs.leadUpdate.open()
        this.close()
      } else {
        uni.showToast({
          title: '请选择处方',
          icon: 'none'
        })
        return false
      }
    },
    changeVisible(e) {
      if (!e.show) {
        this.tabs = [
          {
            title: '相同诊断',
            isDone: false,
            query: {
              doctorID: '',
              doctorName: '',
              patientID: '',
              patientName: '',
              diagnosis: '',
              drugName: '',
              pageNum: 1,
              pageSize: 10
            },
            list: []
          },
          {
            title: '同一受者',
            prescripChannel: 1,
            type: [
              {
                isDone: false,
                query: {
                  doctorID: '',
                  doctorName: '',
                  patientID: '',
                  patientName: '',
                  diagnosis: '',
                  drugName: '',
                  prescripChannel: 1,
                  pageNum: 1,
                  pageSize: 10
                },
                list: []
              },
              {
                isDone: false,
                query: {
                  doctorID: '',
                  doctorName: '',
                  patientID: '',
                  patientName: '',
                  diagnosis: '',
                  drugName: '',
                  prescripChannel: 2,
                  pageNum: 1,
                  pageSize: 10
                },
                list: []
              }
            ]
          },
          {
            title: '我的处方',
            isDone: false,

            query: {
              pageNum: 1,
              pageSize: 10,
              doctorID: '',
              state: '1',
              templateType: '1'
            },
            list: []
          },
          {
            title: '公共处方',
            isDone: false,
            query: {
              pageNum: 1,
              pageSize: 10,
              doctorID: '',
              state: '1',
              templateType: '2'
            },
            list: []
          }
        ]
      }
    },
    changeChannel(val) {
      this.channel = val

      if ([1].includes(this.activeIndex)) {
        this.tabList.type[this.channel - 1].query.prescripChannel = val
        this.tabList.type[this.channel - 1].query.pageNum = 1
        this.getPreList()
      }
    },
    close() {
      this.tabs = [
        {
          title: '相同诊断',
          isDone: false,
          query: {
            doctorID: '',
            doctorName: '',
            patientID: '',
            patientName: '',
            diagnosis: '',
            drugName: '',
            pageNum: 1,
            pageSize: 10
          },
          list: []
        },
        {
          title: '同一受者',
          prescripChannel: 1,
          type: [
            {
              isDone: false,
              query: {
                doctorID: '',
                doctorName: '',
                patientID: '',
                patientName: '',
                diagnosis: '',
                drugName: '',
                prescripChannel: 1,
                pageNum: 1,
                pageSize: 10
              },
              list: []
            },
            {
              isDone: false,
              query: {
                doctorID: '',
                doctorName: '',
                patientID: '',
                patientName: '',
                diagnosis: '',
                drugName: '',
                prescripChannel: 2,
                pageNum: 1,
                pageSize: 10
              },
              list: []
            }
          ]
        },
        {
          title: '我的处方',
          isDone: false,

          query: {
            pageNum: 1,
            pageSize: 10,
            doctorID: '',
            state: '1',
            templateType: '1'
          },
          list: []
        },
        {
          title: '公共处方',
          isDone: false,

          query: {
            pageNum: 1,
            pageSize: 10,
            doctorID: '',
            state: '1',
            templateType: '2'
          },
          list: []
        }
      ]
      if (!this.$refs.leadDrug) {
        return false
      }
      this.channel = 1
      this.tabList.prescripChannel = 1
      this.$emit('update:visible', false)
      this.$refs.leadDrug.close()
    },
    open() {
      this.activeIndex = 0

      this.$emit('update:visible', true)

      this.$refs.leadDrug.open()
    }
  },
  beforeDestroy() {
    this.$bus.off('createNewPre')
    this.$bus.off('showSelectPre')
    this.$bus.off('clickHistory')
  }
}
</script>

<style lang="scss" scoped>
.outside_wrap {
  // position: relative;
  ::v-deep .tab__item {
    width: 4rem;
    text-align: center;
    line-height: 1.706667rem;
  }
  ::v-deep .tabBlock {
    border-top-left-radius: 0.213333rem;
    border-top-right-radius: 0.213333rem;
    border-style: none;
  }

  ::v-deep .tab {
    .tab__item--active {
      font-size: 0.853333rem;
      color: #222222;
      font-weight: 600;
    }
  }

  ::v-deep .tab__line {
    width: 0.64rem !important;
    height: 0.128rem;
  }
}
.channelClass {
  display: flex;
  padding: 0.512rem;
  ::v-deep .mr20 {
    margin-right: 0.426667rem;
  }
}
.gridClass {
  background-color: #fff;
  height: 18.346667rem;
  overflow-y: scroll;
  z-index: 1100;

  .ofPatient {
    height: 18.773333rem;
    overflow-y: scroll;
    .isBottom {
      height: 2.133333rem;
      color: #888;
      text-align: center;
      line-height: 1.28rem;
    }
  }
}

.footer-box {
  text-align: center;
  width: 686ux;
  height: 1.877333rem;
  background: #0089ff;
  border-radius: 0.938667rem;
  line-height: 1.877333rem;
  font-size: 0.682667rem;
  font-weight: 500;
  .btn {
    color: #fff;
  }
}
</style>
